import React, { Component } from "react";
import { connect } from "react-redux";
import ImPolyline from "./ImPolyline";
import WayPoints from "./RouteMasterEditWP/WayPoints";
import WPFloatingBox from "./RouteMasterEditWP/WPFloatingBox";
import AutoWaypoints from "./RouteMasterEditWP/AutoWaypoints";
import RoutesViewBoxes from "./RouteMasterEditWP/RoutesViewBoxes";

import { Marker } from "@vis.gl/react-google-maps";

// @vis.gl/react-google-maps' <Marker> calls marker.setPosition() in an effect and
// throws "not a LatLng or LatLngLiteral" when lat/lng aren't real numbers. These
// origin/desc markers start as null and the lat/lng can arrive as strings, so
// coerce + validate before rendering.
const toLatLng = (p) => {
  if (!p) return null;
  const lat = Number(p.lat);
  const lng = Number(p.lng);
  return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
};

class RouteMaster extends Component {
  render() {
    const originPosition = toLatLng(this.props.marker_origin);
    const descPosition = toLatLng(this.props.marker_desc);

    // When editable waypoints exist (edit master route flow), <WayPoints> already
    // renders the first/last pins with the same dd-start/dd-end icons. Showing the
    // standalone origin/desc markers too produces duplicate start/end pins, so only
    // render them when there are no editable waypoints (e.g. the manage/candidate
    // view, which has no other endpoint indicator).
    const hasEditableWaypoints =
      Array.isArray(this.props.waypoints) && this.props.waypoints.length > 0;
    return (
      // https://developers.google.com/maps/documentation/javascript/reference/polyline#PolylineOptions
      // visible
      // defaultVisible

      <React.Fragment>
        {this.props.show_master_or_candidate !== 2 &&
          this.props.masterPolylineList &&
          this.props.masterPolylineList.length > 0 &&
          this.props.masterPolylineList.map((polyline, index) => {
            return (
              <ImPolyline
                key={polyline.id != null ? polyline.id : index}
                id={polyline.id}
                path={polyline.path}
                editable={polyline.editable}
                info={polyline.info}
                isBackup={polyline.isBackup}
              />
            );
          })}

        {this.props.show_master_or_candidate === 2 &&
          this.props.candidatePolylineList &&
          this.props.candidatePolylineList.length > 0 &&
          this.props.candidatePolylineList.map((polyline, index) => {
            return (
              <ImPolyline
                key={polyline.id != null ? polyline.id : index}
                id={polyline.id}
                path={polyline.path}
                editable={polyline.editable}
                info={polyline.info}
              />
            );
          })}

        {this.props.formManage.page === "manage" &&
          this.props.candidate_waypoints &&
          this.props.candidate_waypoints.map((wp, index) => {
            const position = toLatLng(wp);
            if (!position) return null;
            return (
              <Marker
                key={"cand-wp-" + index}
                position={position}
                draggable={false}
                clickable={false}
                icon={{
                  path: window.google.maps.SymbolPath.CIRCLE,
                  scale: 5,
                  fillColor: "#1976d2",
                  fillOpacity: 1,
                  strokeColor: "#ffffff",
                  strokeWeight: 1,
                }}
              />
            );
          })}

        <WayPoints legs={this.props.legs} waypoints={this.props.waypoints} problematicWaypoints={this.props.problematicWaypoints} />

        {this.props.waypoints.constructor === Array &&
          this.props.waypoints.length > 1 && <WPFloatingBox></WPFloatingBox>}

        {this.props.formManage.page === "master_route" &&
          this.props.legs.length > 0 && <AutoWaypoints />}

        {this.props.formManage.page === "list" &&
          this.props.routesview.constructor === Array &&
          this.props.routesview.length > 0 && (
            <RoutesViewBoxes
              routesview={this.props.routesview}
            ></RoutesViewBoxes>
          )}

        {
          //------ Origin - Desc Marker ------//
        }
        <div>
          {!hasEditableWaypoints && originPosition && (
            <Marker
              position={originPosition}
              icon={{
                url: "https://www.google.com/mapfiles/dd-start.png",
                labelOrigin: new window.google.maps.Point(19, 14),
                scaledSize: new window.google.maps.Size(22, 36),
                size: new window.google.maps.Size(22, 36),
              }}
            />
          )}
          {!hasEditableWaypoints && descPosition && (
            <Marker
              position={descPosition}
              icon={{
                url: "https://www.google.com/mapfiles/dd-end.png",
                labelOrigin: new window.google.maps.Point(19, 14),
                scaledSize: new window.google.maps.Size(22, 36),
                size: new window.google.maps.Size(22, 36),
              }}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = function (state) {
  console.log(state);
  return {
    formManage: state.ui.formManage,
    markerGroup: state.map.markerGroup,
    markerList: state.map.markerList,
    circleList: state.map.circleList,
    candidatePolylineList: state.map.candidatePolylineList,
    candidate_waypoints: state.map.candidate_waypoints,
    masterPolylineList: state.map.masterPolylineList,
    legs: state.map.legs,
    waypoints: state.map.waypoints,
    problematicWaypoints: state.map.problematicWaypoints,
    routesview: state.map.routesview,
    marker_origin: state.map.marker_origin,
    marker_desc: state.map.marker_desc,
    show_master_or_candidate: state.map.show_master_or_candidate,
  };
};

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(RouteMaster);
